import { IClient, IClinician } from "intake_shared/src/types";
import {
    isEligibleForIntakeSession,
    meetsIntakeSessionClientAndBookingRequirements,
} from "../../../../v2utils";

export type SupervisorIntakeBookingStatus =
    | "booked"
    | "not-booked"
    | "not-required"
    | "unknown";

export function getSupervisorIntakeBookingStatus(
    client: IClient,
    cliniciansLookup: Record<string, IClinician>
): SupervisorIntakeBookingStatus {
    let hasRequiredIntake = false;
    let hasUnknownEligibility = false;
    let hasUnknownUnbookedIntake = false;

    for (const booking of client.held_bookings ?? []) {
        const appointmentCheck = client.appointment_checks?.[booking.id];
        if (appointmentCheck?.supervisor_intake_not_required) {
            continue;
        }

        if (!meetsIntakeSessionClientAndBookingRequirements(client, booking)) {
            continue;
        }

        const clinician = cliniciansLookup[booking.clinician_id];
        if (!clinician) {
            hasUnknownEligibility = true;
            if (!booking.supervisor_intake_session) {
                hasUnknownUnbookedIntake = true;
            }
            continue;
        }

        if (!isEligibleForIntakeSession(client, clinician, booking)) {
            continue;
        }

        hasRequiredIntake = true;
        if (!booking.supervisor_intake_session) {
            return "not-booked";
        }
    }

    if (hasUnknownUnbookedIntake) {
        return "unknown";
    }

    if (hasRequiredIntake) {
        return "booked";
    }

    return hasUnknownEligibility ? "unknown" : "not-required";
}
